<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useLibraryStore } from '@/stores/library.store';
import { fmtNumber } from '@/utils/format';

/** Sidebar pastidagi indeks kartasi (prototipdagi "Kunlik maqsad" o'rnida) — Ko'rsatkichlarimga olib boradi */
const { t } = useI18n();
const library = useLibraryStore();
const percent = computed(() =>
  Math.max(0, Math.min(100, Math.round(library.index?.total_index_percentage ?? 0))),
);
</script>

<template>
  <div class="goal-card">
    <div class="goal-card__top">
      <span>{{ t('library.myIndex') }}</span>
      <b>{{ library.index ? percent + '%' : '—' }}</b>
    </div>
    <span class="bar"><i :style="{ width: percent + '%' }" /></span>
    <p class="goal-card__note">
      {{
        t('hero.booksPassed', {
          passed: fmtNumber(library.stats.passed),
          total: fmtNumber(library.stats.total),
        })
      }}
    </p>
    <RouterLink class="btn btn--primary btn--sm" :to="{ name: 'my-stats' }">{{
      t('nav.myStats')
    }}</RouterLink>
  </div>
</template>

<style scoped>
.goal-card {
  margin-top: auto;
  border: var(--hair) solid var(--line);
  border-radius: var(--r-lg);
  padding: var(--s-2);
  background: var(--surface-2);
}
.goal-card__top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--s-icon);
  font-size: var(--fs-label);
}
.goal-card__top span {
  color: var(--ink-3);
}
.goal-card__top b {
  font-weight: var(--fw-bold);
  font-variant-numeric: tabular-nums;
}
.goal-card .bar {
  margin: var(--s-tight) 0;
}
.goal-card__note {
  font-size: var(--fs-label);
  color: var(--ink-3);
}
.goal-card .btn {
  width: 100%;
  margin-top: var(--s-min);
}
</style>
